import Modal from "../../../common/Modal";
import React from "react";
import {sendFarmCommandEvent} from "../../../../services/socketEventsService";
import {FARM_EVENT_TYPES, SMART_FARM_COMMANDS} from "../../../../services/FarmService";

export const StopCurrentModal = (props) => {

    const {farmCell, cancelModal, saveFarmEvent} = props;

    const handleStopCurrent = () => {
        sendFarmCommandEvent(farmCell.system_code, SMART_FARM_COMMANDS.RELAY_COMMAND, 0);
        setTimeout(() => {
            sendFarmCommandEvent(farmCell.system_code, SMART_FARM_COMMANDS.RELAY_COMMAND, 0);
            saveFarmEvent(FARM_EVENT_TYPES.RELAY_COMMAND, 0);
        }, 5000);
        cancelModal();
    };

    return (
        <Modal
            title="Couper le courant de l'imprimante"
            description={`Etes-vous sûr de vouloir couper le courant de l'imprimante ? L'imprimante va s'éteindre.`}
            buttons={[
                {label: 'Oui, couper le courant', callback: handleStopCurrent}
            ]}
            cancelCallback={() => cancelModal()}
        />
    );
}
